/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import { mergeDeep } from '@root/utility'

import { handleChange } from '@/Form/Functions/eventsHandling'
import getFormStatus    from '@/Form/Functions/getFormStatus'

import FormElement from '@/Form/toolkit/FormElement'

import bemit from '@function/bemit'

import _ from 'lodash';

const { app, qwest } = window;

export default class BillingAddress extends Component
{
	state =
	{
		form_data: { },
		status_messages: { },

		user_infos: { },

		initialized: false
	};

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'serverOrderProcessUpdate',
			cb: component.handleProcessFetched
		});

		app.push(
		{
			event: 'orderProcessErrorsUpdate',
			cb: component.handleErrorsUpdate
		});

		app.push(
		{
			event: 'sessionChange',
			cb: component.initValues
		});

		component.initValues('BillingAddress');
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'serverOrderProcessUpdate',
			cb: component.handleProcessFetched
		});

		app.delete(
		{
			event: 'orderProcessErrorsUpdate',
			cb: component.handleErrorsUpdate
		});

		app.delete(
		{
			event: 'sessionChange',
			cb: component.initValues
		});
	}

	handleErrorsUpdate = () =>
	{
		const component = this, props = this.props, state = this.state;

		const errors = (app.state.order_process.errors || { }).billing;

		let status_messages = Object.assign({ }, (errors.status_messages || { }));

		component.setState(
		{
			error: (errors || { }).error,
			status_messages: status_messages
		});
	}

	handleProcessFetched = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			form_data: mergeDeep({ }, app.state.order_process['billing'])
		});

		component.initValues('BillingAddress');
	}

	initValues = (source) =>
	{
		const component = this, props = this.props, state = this.state;

		const session = app.state.session;

		if (!session?.id || !app.state.order_process?.fetched)
		{
			return;
		}

		if (state.initialized === true) return;

		let form_data = component.state.form_data;

		const update = { };

		if (app.state.session.permissions.title !== 'EC')
		{
			[
				{
					form_name: 'billing[email]',
					session_name: 'login'
				},
				{
					form_name: 'billing[firstname]',
					session_name: 'firstname'
				},
				{
					form_name: 'billing[lastname]',
					session_name: 'lastname'
				},
				{
					form_name: 'billing[line_1]',
					session_name: 'address.line_1'
				},
				{
					form_name: 'billing[line_2]',
					session_name: 'address.line_2'
				},
				{
					form_name: 'billing[zip_code]',
					session_name: 'address.zip_code'
				},
				{
					form_name: 'billing[city]',
					session_name: 'address.city'
				},
				{
					form_name: 'billing[phone]',
					session_name: 'phone'
				}
			]
			.filter(function (data)
			{
				if (!source) return false;

				if (['initState', 'login'].includes(source.label))
				{
					return false;
				}

				if (source === 'BillingAddress') return true;
			})
			.forEach(function (data)
			{
				let session_data = _.cloneDeep(session);

				let find = data.session_name.split('.').find(function (prop)
				{
					if (session_data.hasOwnProperty(prop))
					{
						session_data = session_data[prop];
					}
					else
					{
						return true;
					}
				});

				if (form_data[data.form_name]) return;

				const process_value = app.state
				.order_process['billing'][data.form_name];

				if (process_value)
				{
					update[data.form_name] = process_value;
				}
				else if (!find && session_data)
				{
					update[data.form_name] = session_data;
				}
			});
		}
		else
		{
			[
				{
					form_name: 'billing[line_1]',
					session_name: 'EC.address.line_1'
				},
				{
					form_name: 'billing[line_2]',
					session_name: 'EC.address.line_2'
				},
				{
					form_name: 'billing[zip_code]',
					session_name: 'EC.address.zip_code'
				},
				{
					form_name: 'billing[city]',
					session_name: 'EC.address.city'
				},
				{
					form_name: 'billing[phone]',
					session_name: 'EC.phone'
				}
			]
			.filter(function (data)
			{
				if (!source) return false;

				if (source === 'BillingAddress') return true;
			})
			.forEach(function (data)
			{
				let session_data = _.cloneDeep(session);

				let find = data.session_name.split('.').find(function (prop)
				{
					if (session_data.hasOwnProperty(prop))
					{
						session_data = session_data[prop];
					}
					else
					{
						return true;
					}
				});

				if (form_data[data.form_name]) return;

				if (app.state.order_process['billing'][data.form_name])
				{
					update[data.form_name] = app.state
					.order_process['billing'][data.form_name];
				}
				else if (!find && session_data)
				{
					update[data.form_name] = session_data;
				}
			});

			update['billing[name]'] = app.state.session.EC.company;
		}

		const state_update = { ...form_data, ...update };

		app.state.order_process['billing'] = _.cloneDeep(state_update);

		component.setState(
		{
			form_data: state_update,

			initialized: true
		});

		app.emit('order_processChange', { source: 'BillingAddress' });
	}

	handleChange = (e, data) =>
	{
		const component = this;

		handleChange.bind(component)(e, data);

		app.state.order_process['billing'] = component.state.form_data;

		if (!e)
		{
			let store_value = app.state.order_process['shipping'][data.name];

			if (typeof store_value !== 'undefined' && store_value !== data.value)
			{
				return;
			}
			else if (typeof store_value === 'undefined' && data.value === '')
			{
				return;
			}
		}

		if (e)
		{
			app.emit('order_processChange', { source: 'BillingAddress' });
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const is__EC =  app.state.session.permissions?.title === 'EC';

		const user_email = !is__EC ?
		(
			<div className="o-grid__item">
				<FormElement className={ bemit('c-form-element', ['order']) }
					name="billing[email]" type="email" data={ state.form_data }
					label="Adresse e-mail" status={ state.status_messages }
					onChange={ component.handleChange }
					readOnly
				/>
			</div>
		)
		: undefined;

		const name_fields = is__EC ?
		(
			<div className="o-grid__item">
				<FormElement name="billing[name]"
					className={ bemit('c-form-element', ['order']) }
					type="text" data={ state.form_data }
					label="Adressé à" status={ state.status_messages }
					onChange={ component.handleChange }
					readOnly
				/>
			</div>
		)
		:
		(
			<>
				<div className="o-grid__item">
					<FormElement name="billing[firstname]"
						className={ bemit('c-form-element', ['order']) }
						type="text" data={ state.form_data }
						label="Prénom" status={ state.status_messages }
						onChange={ component.handleChange }
						readOnly
					/>
				</div>

				<div className="o-grid__item">
					<FormElement name="billing[lastname]"
						className={ bemit('c-form-element', ['order']) }
						type="text" data={ state.form_data }
						label="Nom" status={ state.status_messages }
						onChange={ component.handleChange }
						readOnly
					/>
				</div>
			</>
		);

		var output =
		(
			<div className="c-order-process__step">

				<h2 className="c-order-process__title">
					<span className="c-order-process__title-number">1</span>
					Adresse de Facturation
				</h2>

				{ getFormStatus(state) }

				<div className="u-negative-margin">

					<div className="o-grid-2">

						{ name_fields }

						{ user_email }

						<div className="o-grid__item">
							<FormElement name="billing[phone]"
								className={ bemit('c-form-element', ['order']) }
								type="tel" data={ state.form_data }
								label="Téléphone" status={ state.status_messages }
								onChange={ component.handleChange }
							/>
						</div>

						<div className="o-grid__item">
							<FormElement name="billing[line_1]"
								className={ bemit('c-form-element', ['order']) }
								type="text" data={ state.form_data }
								label="Adresse" status={ state.status_messages }
								onChange={ component.handleChange }
							/>
						</div>

						<div className="o-grid__item">
							<FormElement name="billing[line_2]"
								className={ bemit('c-form-element', ['order']) }
								type="text" data={ state.form_data }
								label="Complément d'adresse" status={ state.status_messages }
								onChange={ component.handleChange }
							/>
						</div>

						<div className="o-grid__item">
							<FormElement name="billing[zip_code]"
								className={ bemit('c-form-element', ['order']) }
								type="text" data={ state.form_data }
								label="Code postal" status={ state.status_messages }
								onChange={ component.handleChange }
							/>
						</div>

						<div className="o-grid__item">
							<FormElement name="billing[city]"
								className={ bemit('c-form-element', ['order']) }
								type="text" data={ state.form_data }
								label="Ville" status={ state.status_messages }
								onChange={ component.handleChange }
							/>
						</div>

					</div>

				</div>

			</div>
		);

		return output;
	}
}